import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers, addUser } from '../store/userSlice';
import { fetchRoles } from '../store/roleSlice';

const UserManagement = () => {
  const dispatch = useDispatch();
  const { list: users, loading, error } = useSelector((state) => state.users);
  const { list: roles } = useSelector((state) => state.roles);
  
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ username: '', email: '', password: '', role: '' });

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchRoles());
  }, [dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(addUser(formData));
    if (!result.error) {
      setShowForm(false);
      setFormData({ username: '', email: '', password: '', role: '' });
      dispatch(fetchUsers());
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h2 style={{ color: '#1f2937' }}>Manage Users</h2>
          <p style={{ color: '#6b7280' }}>View and manage all employees in the system.</p>
        </div>
        <button className="btn btn-primary" style={{ padding: '0.6rem 1.25rem', borderRadius: '50px' }} onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ Add New User'}
        </button>
      </div>

      {showForm && (
        <div className="card" style={{ marginBottom: '2rem' }}>
          <h3 style={{ marginBottom: '1.5rem', color: '#111827' }}>Create User</h3>
          <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
            <div>
              <label>Username</label>
              <input value={formData.username} onChange={e => setFormData({...formData, username: e.target.value})} required />
            </div>
            <div>
              <label>Email</label>
              <input type="email" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} required />
            </div>
            <div>
              <label>Password</label>
              <input type="password" value={formData.password} onChange={e => setFormData({...formData, password: e.target.value})} required />
            </div>
            <div>
              <label>Role</label>
              <select value={formData.role} onChange={e => setFormData({...formData, role: e.target.value})} required>
                <option value="">Select a role</option>
                {roles.map(r => (
                  <option key={r.id} value={r.name}>{r.name}</option>
                ))}
              </select>
            </div>
            <div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1rem' }}>
              <button type="button" className="btn" style={{ background: '#f3f4f6', color: '#374151' }} onClick={() => setShowForm(false)}>Cancel</button>
              <button type="submit" className="btn btn-primary" style={{ borderRadius: '50px', padding: '0.6rem 1.5rem' }}>Save User</button>
            </div>
          </form>
        </div>
      )}

      {error && <p style={{ color: 'var(--danger)' }}>Error loading users.</p>}
      
      {loading && users.length === 0 ? <p style={{ color: '#6b7280' }}>Loading users...</p> : (
        <div className="card" style={{ padding: '0', overflow: 'hidden' }}>
          <table>
            <thead>
              <tr style={{ background: '#f9fafb' }}>
                <th>Username</th>
                <th>Email</th>
                <th>Role</th>
                <th style={{ textAlign: 'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.id}>
                  <td>
                    <div style={{ fontWeight: '600', color: '#4f46e5' }}>{user.username}</div>
                  </td>
                  <td style={{ color: '#4b5563' }}>{user.email}</td>
                  <td>
                    <span style={{ 
                      background: '#f3f4f6', 
                      color: '#4b5563',
                      padding: '4px 8px', 
                      borderRadius: '4px',
                      fontSize: '0.75rem',
                      fontWeight: '600',
                      letterSpacing: '0.05em'
                    }}>
                      {user.role}
                    </span>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <button className="btn" style={{ background: 'transparent', color: '#9ca3af', padding: '0.4rem' }}>✎</button>
                  </td>
                </tr>
              ))}
              {users.length === 0 && (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>No users found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
